import { useTranslation } from "react-i18next";
import { useSharedStore } from "shared/stores/sharedStore";
import { useUserDetailsStore } from "shared/stores/userDetailsStore";
import "styles/flows/forex/passwordManager/passwordManagerStep.css";

const PasswordManagerStep = ({
  next,
}: {
  next: (goMeta?: boolean) => void;
}) => {
  const { t } = useTranslation();
  const { brand } = useSharedStore();

  const updateUserDetails = useUserDetailsStore((state) => state.userDetails);

  const BASE_ICON_BASE = "/assets/svg/common/";

  // Default values
  let EditIconName = "EditIcon";
  let LogoIconName = "FPIcon";
  let ArrowEnabledIconName = "ArrowEnabledIcon";
  let WarningBoxText = "PasswordManager.WarrningBox";
  let MainPasswordText = "PasswordManager.MainPasswordFortrade";
  let MainPasswordSubText = "PasswordManager.MainPasswordSubText";

  switch (brand) {
    case "thor-thunder":
      // Using default values, no need to reassign
      break;
    case "draco-might":
      EditIconName = "EditIconGreen";
      LogoIconName = "GYIcon";
      ArrowEnabledIconName = "ArrowRightGreen";
      WarningBoxText = "PasswordManager.WarrningBoxDM";
      MainPasswordText = "PasswordManager.MainPasswordDM";
      MainPasswordSubText = "PasswordManager.MainPasswordSubTextDM";
      break;
    case "zephir-blade":
      LogoIconName = "KPIcon";
      WarningBoxText = "PasswordManager.WarrningBoxZB";
      MainPasswordText = "PasswordManager.MainPasswordFortradeZB";
      MainPasswordSubText = "PasswordManager.MainPasswordSubTextZB";
      break;
    case "mermaid-haven":
      EditIconName = "EditIconGreen";
      ArrowEnabledIconName = "ArrowRightGreen";
      LogoIconName = "GCMAsiaLight";
      MainPasswordText = "PasswordManager.MainPasswordMH";
      WarningBoxText = "PasswordManager.WarrningBoxMH";
      MainPasswordSubText = "PasswordManager.MainPasswordSubTextMH";
      break;
    default:
      console.error("Brand not found");
      break;
  }

  if (updateUserDetails === null) {
    console.error("User details are not loaded yet");
    return null;
  }

  function onNextStep() {
    next();
  }

  return (
    <>
      <h2>{t("PasswordManager.Title")}</h2>
      <h3>{t("PasswordManager.SubTitle")}</h3>
      {updateUserDetails.ShouldSeePasswordPopup > 0 && (
        <div className="warrning-box">
          <img
            src={`${BASE_ICON_BASE}WarrningIcon.svg`}
            width={22}
            height={22}
          />
          <p>{t(WarningBoxText)}</p>
        </div>
      )}
      <div className="manager" onClick={onNextStep}>
        <div className="manager-left">
          <img
            src={`${BASE_ICON_BASE}${LogoIconName}.svg`}
            width={34}
            height={34}
          />
          <div className="manager-text">
            <p>{t(MainPasswordText)}</p>
            <p>{t(MainPasswordSubText)}</p>
          </div>
          {updateUserDetails.ShouldSeePasswordPopup === 0 ? (
            <img
              src={`${BASE_ICON_BASE}${EditIconName}.svg`}
              width={20}
              height={20}
            />
          ) : (
            <div className="edit-setup">{t("PasswordManager.Setup")}</div>
          )}
        </div>
      </div>

      <div
        className={`other-accounts ${
          updateUserDetails.ShouldSeePasswordPopup > 0 && "disabled"
        }`}
        onClick={() => next(true)}
      >
        <h3>{t("PasswordManager.ManageMetaAccounts")}</h3>
        {updateUserDetails.ShouldSeePasswordPopup > 0 ? (
          <img
            src={`${BASE_ICON_BASE}ArrowGrayIcon.svg`}
            width={16}
            height={16}
          />
        ) : (
          <img
            src={`${BASE_ICON_BASE}${ArrowEnabledIconName}.svg`}
            width={16}
            height={16}
          />
        )}
      </div>
    </>
  );
};

export default PasswordManagerStep;
